import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  FormGroup,
  Input,
  Badge,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import {
  AGENCY_USER_LIST_URL,
  USER_DETAILS_URL,
  USER_DELETE_URL,
  USER_LIST_DELETE
} from "../../../../utils/APIEndpoints";
import { authHeader } from "../../../../utils/functions/CoreFunctions";
import API from "../../../../redux/actions/API";
import {
  SingleStringFirstLetterCaps,
  getAlertToast,
  getConfirm,
  getCountryCode,
} from "../../../../utils/functions/CustomFunctions";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import CustomViewButton from "../../../common/CustomViewButton";
import CustomTableLoader from "../../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../../common/CustomTableEmptyRecord";
import CustomTableHeader from "../../../common/CustomTableHeader";
import { useParams } from "react-router-dom";
import Create from "../user/create.jsx";
import CustomUserAvatar from "../../../common/CustomUserAvatar";
import CustomEditButton from "../../../common/CustomEditButton";
import CustomDeleteButton from "../../../common/CustomDeleteButton";
import View from "../user/view";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";
import { SET_AGENCY_USER_PROFILE_PICTURE } from "../../../../redux/actions/ActionTypes";
import { useDispatch } from "react-redux";

//Table Columns
const tableColumns = [
  { title: "Profile" },
  { title: "First Name" },
  { title: "Last Name" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Role" },
  { title: "Actions" },
];

const Users = (props) => {
  const dispatch = useDispatch();
  let { id } = useParams();

  //State
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createModal, setCreateModal] = useState();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    address: "",
  });
  const [isAdd, setIsAdd] = useState(false);
  const createToggle = () => setCreateModal(!createModal);
  const [viewModal, setViewModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(0);
  const [selected,setSelected] = useState([]);
  const [selectedlist,setSelectedlist] = useState(false);
  const [active,setActive] = useState(false);

  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
  });

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleReset = () => {
    setFilter({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "",
    });
  };

  const viewToggle = () => setViewModal(!viewModal);

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      count: rowsPerPage || undefined,
      offset: page - 1,
      agencyId: id,
    });
  };

  const viewRecord = async (userId, e) => {
    setCurrentUserId(userId);
    setViewModal(true);
  };

  const saveCallBack = () => {
    getGridData({
      ...filter,
      count: rowsPerPage || undefined,
      offset: currentPage,
      agencyId: id,
    });
    createToggle(false);
  };
  const createRecord = async () => {
    setUserData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "",
      address: "",
    });
    setIsAdd(true);
    setCreateModal(true);
    dispatch({
      type: SET_AGENCY_USER_PROFILE_PICTURE,
      payload: "",
    });
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        url: AGENCY_USER_LIST_URL,
        headers: authHeader(),
        params: queryParams,
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {
          let { firstName, lastName } = record;
          let formattedData = {
            firstName: SingleStringFirstLetterCaps(firstName),
            lastName: SingleStringFirstLetterCaps(lastName),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Edit Record
  const editRecord = async (userId, event) => {
    setLoading(true);
    const options = {
      method: "GET",
      url: USER_DETAILS_URL,
      headers: authHeader(),
      params: { userId },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        setIsAdd(false);
        setUserData(response.data);
        setCreateModal(true);
        dispatch({
          type: SET_AGENCY_USER_PROFILE_PICTURE,
          payload: response.data.profileImage,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const deleteRecordAll = async () => {
    Swal.fire(
      getConfirm("warning", "Are you sure do you want to delete?")
    ).then((result) => {
      if (result.value) {
        deleteAdmin();
      }
    });
  };
 //Delete Record
  const deleteAdmin = async () =>{
    
    console.log(selected.length);
   let values  = [];
   selected.forEach((value) =>{
     values.push({
       "userId": value
     })
   })
   console.log(values) 
   try{
     setLoading(true)
     const option= {
       method : "DELETE",
       url : USER_LIST_DELETE,
       header: authHeader(),
       data: {
         "userList": values
       }
     }
     const response = await API(option)
     const {status} = response.data;
     if(status == "Success"){
       getGridData({
        ...filter,
        count: rowsPerPage || undefined,
        offset: currentPage,
        agencyId: id,
       });
     }
     
     console.log(selected)
   }
   catch(error){
     if(error.response){
       let {data} = error.response;
       Swal.fire(getAlertToast("error",data.message));
     }
   } 
   finally{
     setLoading(false);
   }


 }
  
  const handleRowPerPage = ({ target: { value } }) => {
    setCurrentPage(0);
    setRowsPerPage(value);
  };

  useEffect(() => {
    getGridData({
      ...filter,
      count: rowsPerPage || undefined,
      offset: currentPage,
      agencyId: id,
    });
  }, [rowsPerPage]);

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          count: rowsPerPage,
          offset: currentPage,
          agencyId: id,
        }),
      500
    )
  ).current;

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const onChangeChecked = (e) =>{
   
    console.log(e);
   let list = [];
   list.length = 0;
    if(selectedlist == false || e == true){
      setSelectedlist(true);
      gridData.filter((record) =>{
        selected.push(record.userId)
      
      })
      setSelected(selected);
    }
    else{
      setSelectedlist(false)
     
      gridData.map((record) =>{
        selected.shift(record.userId)
      })
      list.splice(0, selected.length)
      //selected.shift(gridData.userId)
      setSelected(list);
    }
  }
  const cheackvalues  = (e,agency) =>{
    
    console.log(e)
   if(e == true){
     selected.push(agency);
     setSelected([...selected], selected)
   }else{
     selected.shift(agency)
     setSelected([...selected], selected)
     
   }                         
    
 } 

  const { firstName, lastName, email, phoneNumber, role } = filter;
  console.log(selected)
  console.log(selected.length)
  return (
    <Fragment>
      <Row style={{ marginTop: "1rem" }}>
        
        <Col md={9}>
          {isFilterOpen && (
            <Row form>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    onChange={changeFilterField}
                    value={firstName}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    onChange={changeFilterField}
                    value={lastName}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={changeFilterField}
                    value={email}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>+1</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="phoneNumber"
                      placeholder="Phone Number"
                      onChange={changeFilterField}
                      value={phoneNumber}
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="select"
                    name="role"
                    placeholder="Role"
                    onChange={changeFilterField}
                    value={role}
                  >
                    <option value={""}>- Show All Roles -</option>
                    <option value={"Merchant Admin"}>Merchant Admin</option>
                    <option value={"Merchant Manager"}>Merchant Manager</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <div style={{ marginTop: "4px" }}>
                  <Button color="danger" onClick={handleReset}>
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          )}
        </Col>
            
        <Col md={3}>
          <div className="tableTitleBg mb-4">
            <i
              className="fas fa-filter"
              style={{
                float: "right",
                margin: "10px 7px 3px 16px",
                fontSize: "19px",
                cursor: "pointer",
              }}
              onClick={filterToggle}
            ></i>
          </div>
          <Button
            className="f-r"
            color="primary"
            onClick={createRecord}
            style={{ marginBottom: "1rem" }}
          >
            <i className="fas fa-user-plus"></i> New User
          </Button>
          <Col>
         {(selected.length  > 0) ? 
            <CustomDeleteButton
            onClick={deleteRecordAll}
            />
          : ""}
          
      
          </Col>
        </Col>
              
      </Row>

      <Table responsive hover>
        {/* Table Header */}
        {/* <CustomTableHeader tableColumns={tableColumns} /> */}
        <thead style={{backgroundColor:'#eee'}}>
        <tr>  
        <th>{
              <Checkbox
              icon={<Icon.FiCheck color="#174A41" size={14} />}
              borderColor="#D7C629"
               checked={selectedlist}
              onChange={onChangeChecked} 
              style={{ cursor: "pointer" }}
            />
              }
            </th>
          
            {tableColumns.map(({title},key) =>         
                <th key={`head_list_${key}`}>{title}</th>
            )}
            </tr>
        </thead>
        {/* Table Header */}
        <tbody>
          {loading ? (
            // Table Loader
            <CustomTableLoader columnsCount={tableColumns.length} />
          ) : (
            // Table Loader
            <Fragment>
              {!gridData.length ? (
                //  Empty Record
                <CustomTableEmptyRecord columnsCount={tableColumns.length} />
              ) : (
                //  Empty Record
                <Fragment>
                  {gridData.map((record, key) => (
                    <tr key={`record_key_${key}`}>
                      <td>{
                        <Checkbox
                        icon={<Icon.FiCheck color="#174A41" size={14} />}
                        borderColor="#D7C629"
                        checked={selectedlist}
                        onChange={(e) => cheackvalues(e,record.userId)} 
                        style={{ cursor: "pointer" }}
                      />
                      }</td>
                      <td>
                        {/* Custom Avatar */}
                        <CustomUserAvatar srcPath={record.profileImage} />
                        {/* Custom Avcatar */}
                      </td>
                      <td>{record.firstName}</td>
                      <td>{record.lastName}</td>
                      <td>{record.email}</td>
                      <td>
                        {getCountryCode()}
                        {record.phoneNumber}‎
                      </td>
                      <td>
                        <Badge
                          color={
                            record.role === "Merchant Admin"
                              ? "primary"
                              : "secondary"
                          }
                        >
                          {record.role}
                        </Badge>
                        ‎
                      </td>
                      <td style={{ display: "flex" }}>
                        {/* Custom Remove Button  */}
                        {/* <CustomDeleteButton
                          keyvalue={key}
                          data-user_id={record.userId}
                          onClick={(e) => deleteRecord(record.userId, e)}
                        /> */}
                        {/* Custom Remove Button  */}

                        {/* Custom Edit Button  */}
                        <CustomEditButton
                          keyvalue={key}
                          data-user_id={record.userId}
                          onClick={(e) => editRecord(record.userId, e)}
                        />
                        {/* Custom Edit Button  */}

                        {/* Custom View Button  */}
                        <CustomViewButton
                          keyvalue={key}
                          data-user_id={record.userId}
                          onClick={(e) => viewRecord(record.userId, e)}
                        />
                        {/* Custom View Button  */}
                      </td>
                    </tr>
                  ))}
                </Fragment>
              )}
            </Fragment>
          )}
        </tbody>
        {/* Table Body */}
      </Table>

      {gridData.length ? (
        <div className="d-flex py-4 justify-content-end space_between">
          <div className="space_between">
            <div>
              <p className="per_page">Records/Page</p>
            </div>
            <div>
              <FormGroup>
                <Input
                  className="pagi_drop"
                  type="select"
                  name="rowsPerPage"
                  onChange={handleRowPerPage}
                  value={rowsPerPage}
                >
                  <option value={""}>Show All</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Input>
              </FormGroup>
            </div>
          </div>
          {rowsPerPage && (
            <div>
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentPage + 1}
                itemsCountPerPage={rowsPerPage}
                totalItemsCount={totalRecords}
                onChange={onPageChanged}
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {/* create Modal */}
      {createModal && (
        <Create
          modal={createModal}
          toggle={createToggle}
          data={userData}
          isAdd={isAdd}
          saveCallBack={saveCallBack}
        />
      )}
      {/* end create Modal */}

      {/* View Dialog */}
      {viewModal && (
        <View
          userId={currentUserId}
          viewToggle={viewToggle}
          viewModal={viewModal}
        />
      )}
      {/* View Dialog */}
    </Fragment>
  );
};

export default Users;
